import React, { useState, useContext, useEffect } from 'react'
import CustomerAccountItemHeader from './CustomerAccountItemHeader'
import CustomerAccountItemInner from './CustomerAccountItemInner'
import CustomerAccountItemFooter from './CustomerAccountItemFooter'
import { getCustomersAccountsList } from '../CustomersAccountsFunctions'
import { appContext } from '../../../App'

export const customerAccountItemControllerContext = React.createContext()

const useCustomerAccountItemController = (props) => {
  const app = useContext(appContext)
  const { id } = props
  const [customerAccount, setCustomerAccount] = useState(null)

  // Filters
  const dateFilter = {
    date: {
      date_created_from: '',
      date_created_to: '',
      date_modified_from: '',
      date_modified_to: ''
    }
  }

  const sortByFilter = { sort_by: { date_time_created: -1 }}

  useEffect(() => {
    getCustomersAccountsList(app, {...dateFilter, ...sortByFilter})
    .then(res => {
      setCustomerAccount(res.find(ca => ca._id === id))
    })

    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const refreshCustomerAccount = async () => {
    await getCustomersAccountsList(app, {...dateFilter, ...sortByFilter})
  }

  const obj = {
    customerAccount,
    refreshCustomerAccount
  }
  return (obj)
}

function CustomerAccountItemController(props) {
  const customerAccountItemController = useCustomerAccountItemController(props)
  return (
    <React.Fragment>
      <customerAccountItemControllerContext.Provider value={customerAccountItemController}>
        <CustomerAccountItemHeader />
        <CustomerAccountItemInner />
        <CustomerAccountItemFooter />
      </customerAccountItemControllerContext.Provider>
    </React.Fragment>
  )
}

export default React.memo(CustomerAccountItemController)